{
  "apply_access": "Apply access rules",
  "badge_calculated": "Calculated",
  "badge_hidden": "Hidden",
  "badge_mandatory": "Mandatory",
  "badge_system": "System",
  "change_field_name": "A field with this name already exists, try changing the field name",
  "change_table_name": "A table with this name already exists, try changing the table name",
  "choose_field_type": "Choose field type",
  "confirmation_delete_field": "Do you want delete this field?",
  "confirmation_delete_section": "Do you want delete this section?",
  "confirmation_delete_table": "Do you want delete this table?",
  "create_fields_for_table": "Create fields for this table",
  "create_new_custom_table": "Create flexible dataset",
  "create_new_field": "Create custom field",
  "create_new_field_type": "Create new {field_type} field",
  "create_new_section": "Group fields by titles",
  "create_new_table": "Create new custom table",
  "create_options": "Create options",
  "currency_description": "For salaries, budgets and payments",
  "custom_fields": "Custom fields",
  "custom_table": "Custom table",
  "custom_table_settings": "Custom table settings",
  "system_table_settings": "System table settings",
  "system_field_title_fallback": "If the title is empty, the default system field name will be used.",
  "system_field_title_reset_hint": "You can restore the localized system field name.",
  "custom_tables": "Custom tables",
  "date_description": "Pick a calendar date",
  "datetime_description": "Pick a calendar date and time",
  "default_value": "Default value",
  "edit_field": "Edit field",
  "edit_field_type": "Edit {field_type} field",
  "edit_option": "Edit option",
  "edit_section": "Edit section",
  "edit_table": "Edit table",
  "email_description": "Set email address",
  "employee_reference_description": "Pick a teammate from the directory",
  "employee_reference_title": "Employee reference",
  "entity_reference_description": "Pick a value from a directory",
  "entity_reference_title": "Directory reference",
  "employee_tab_sidebar_title": "General information",
  "export_with_history": "Export with history",
  "field": "Field",
  "field_deleted": "Field deleted",
  "field_type": "Field type",
  "fields": "Fields",
  "fields_how_works": "Choose what shows up in every profile. Keep it tidy, make it yours",
  "file_description": "Any files from system",
  "for_all_employees": "For all employees",
  "hint": "Hint",
  "historical_description": "This table is used to track changes over time.",
  "historical_title": "Historical table",
  "disable_historical_confirmation_title": "Disable historical table?",
  "disable_historical_confirmation_description": "Row dates will be preserved. The date column and its settings will appear again if you enable history later.",
  "image_description": "Images files from system",
  "information_about_permissions": "{this_entity} won't be visible to anyone unless you set it up in role permissions",
  "just_reminder": "Just a reminder",
  "lets_choose": "Let’s choose who can see it",
  "long_text_description": "For notes, descriptions, or any long-form text",
  "long_text_title": "Long text",
  "make_mandatory": "Make this field required when adding or updating profiles",
  "manage_roles": "Manage in workspace settings",
  "mandatory": "Mandatory",
  "multiple": "Multiple",
  "multiple_description": "You can select multiple answer options",
  "multiple_employees_description": "You can select multiple employees",
  "multiple_references_description": "You can select multiple directory entries",
  "need_help_question": "Need help setting it up further?",
  "new_custom_table": "New custom table",
  "new_field": "New field",
  "new_field_created": "New field created",
  "new_field_is_hidden": "This new field is hidden for now",
  "new_field_is_hidden_information": "No one, including you, can see or use it until access is granted in role permissions. You don’t have permission to make it visible or editable",
  "new_field_ready": "Nice! New field is ready",
  "new_section": "New section",
  "number_description": "Whole numbers or decimals",
  "number_title": "Number",
  "ok_got_it": "Ok, got it",
  "open_role_permissions": "Open role permissions",
  "reference_archived": "Archived",
  "reference_directory": "Directory",
  "link_to_employment_legal_entity": "Link to employment legal entity",
  "link_to_employment_legal_entity_hint": "The value comes from employment data. Permission to edit this column allows changing the employee’s legal entity",
  "link_to_position_department": "Link to position department",
  "link_to_position_department_hint": "The value comes from position data. Permission to edit this column allows changing the employee’s department",
  "link_to_position_division": "Link to position division",
  "link_to_position_division_hint": "The value comes from position data. Permission to edit this column allows changing the employee’s division",
  "link_to_position_location": "Link to position location",
  "link_to_position_location_hint": "The value comes from position data. Permission to edit this column allows changing the employee’s location",
  "options_required_for_select": "You must add at least one option for this select field",
  "percentage_description": "Numbers from 0 to 100",
  "percentage_title": "Percentage",
  "phone_description": "Set mobile phone",
  "section_deleted": "Section deleted",
  "sections": "Sections",
  "set_access": "Set access for each role in your workspace:",
  "set_default_apply_to_all": "Apply this value to all new and existing employee profiles by default",
  "set_default_apply_to_new": "Apply this value to all new employee profiles by default",
  "set_default_value": "Set default value",
  "settings_title": "Employee profile",
  "setup_field_permissions": "Setup field permissions",
  "single_select_description": "Select one option from a list",
  "switch_description": "You can switch on/of this field",
  "switch_title": "Switch",
  "system_table": "System table",
  "table_deleted": "Table deleted",
  "text_description": "One-line text field for simple input",
  "this_field": "This field",
  "this_table": "This table",
  "unavailable_for_this_page": "Unavailable for this page",
  "url_description": "Add a link",
  "value_text": "Value",
  "visibility": "Show",
  "visibility_always": "Always",
  "visibility_never": "Never",
  "visibility_when_filled": "Show when filled",
  "view_all_data": "View all data",
  "who_can_configure": "These teammates can configure access:",
  "who_should_see": "Who should see this field?",
  "hired_via_job": "Hired via recruitment",
  "~": "~",
  "placeholder": "Placeholder",
  "recruiting_settings_title": "Recruitment fields",
  "recruiting_settings_description": "Configure candidate, job and offer fields",
  "applicant_fields": "Candidate fields",
  "applicant_fields_description": "Configure candidate profile fields",
  "recruiting_fields_how_works": "Configure field order, labels, hints, visibility and required fields",
  "job_fields": "Job fields",
  "job_fields_description": "Configure job posting fields",
  "offer_fields": "Offer fields",
  "offer_fields_description": "Configure job offer fields",
  "job_hiring_process": "Hiring process",
  "visible_to_candidate": "Visible to candidate",
  "visible_to_candidate_description": "Show this field on the public offer page and in the offer PDF",
  "make_mandatory_job": "Make this field required for Active and On hold jobs. Draft and Archived jobs can be saved without it",
  "make_mandatory_offer": "Make this field required when creating or editing an offer",
  "job_description_hidden_ai_title": "AI candidate scoring will be unavailable",
  "job_description_hidden_ai_description": "Without a description, the job form won't show the AI block: requirements are generated from the description"
}
